import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SelectOption} from "../../classes/select-option";

@Component({
    selector: 'app-weave-select',
    templateUrl: './weave-select.component.html',
    styleUrls: ['./weave-select.component.scss'],
    standalone: false
})
export class WeaveSelectComponent implements OnInit, OnChanges {
  @Input() data;
  @Input() options: SelectOption[];
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() description: string = "";
  @Input() placeholder: string = "";
  @Input() required: boolean = false;
  @Input() showLabel: boolean = true;
  @Input() isDark: boolean = false;
  @Input() showError: boolean = false;
  @Input() isInline: boolean = false;
  @Input() hasBorder: boolean = true;
  @Input() isLeft: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();

  model: string = "";

  tempValue: any;
  id: string = "";
  message: string = "";

  constructor() {}

  ngOnInit() {
    this.model = this.data;
    this.tempValue = this.data;
    this.id = "weave-select" + Math.floor(Math.random() * 1000);

    this.message = this.label;
    if( this.message.length > 30 || this.message.length == 0 ) {
      this.message = "This field";
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    this.model = this.data;
  }

  onFocusOut() {
    this.showError = false;
    this.focusOut.emit(this.model);
  }

  undo() {
    this.data = this.tempValue;
    this.model = this.tempValue;
  }

}
